// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import GenerateReportButton from '../Buttons/GenerateReportButton'
import Loading from '../Icons/loading.gif'
import Paginate from '../Buttons/Paginate'
import './UserTable.css'

type Props = {
  changeOffset: Function,
  toggleSort: Function,
  data: Array,
  fields: Array,
  page: number,
  totalUsers: number,
  sort: String,
  generateReportClick: Function,
  status: String
}

/**
  * Diplay for user table
  * @class
  * @extends Component
*/
class UserTable extends Component<Props> {
  /** render function */
  render () {
    const fields = this.props.fields
    const headers = fields.map((field, index) =>
      <th
        id={this.props.sort.split(' ')[0] === field.ref ? 'selected' : ''}
        className={this.props.sort.split(' ')[0] === field.ref ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''}
        key={index}
        onClick={(e) => this.props.toggleSort(field.ref)}>
        <span>{field.title}</span>
      </th>)
    const users = this.props.data.map((user, i) => {
      if (user.name === 'Loading') {
        return (<tr key={Math.random()}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else if (user.name === '') {
        return false // removes users from list that does not have name
      } else {
        return (
          <tr key={i}>{fields.map((field) => {
            if (field.ref === 'name') {
              return (<td key={field.ref}><Link to={{ pathname: '/user', search: '?id=' + user._id + '&date=Week&filter=__' }}>{user[field.ref] || '--'} </Link></td>)
            } else if (field.toMap) {
              return (<td key={field.ref}> {field.toMap(user[field.ref]) || '--'}</td>)
            } else if (field.ref === 'appProfiles') {
              if (user[field.ref].length > 1) {
                return <td key={field.ref}><ul>
                  {user[field.ref].map(profile => {
                    return <li key={Math.random()}>{profile}</li>
                  })}
                </ul></td>
              } else {
                return <td key={field.ref}>{user[field.ref]}</td>
              }
            }
            return (
              <td key={field.ref}>{user[field.ref] || '--'} </td>
            )
          })}</tr>
        )
      }
    }
    )
    return (
      <div>
        <div className='table-wrapper'>
          <div className='UserTable'>
            <h4 className='flex align-center space-between'>Users<GenerateReportButton status={this.props.status} generateReportClicked={this.props.generateReportClick} /></h4>
            <table>
              <thead><tr>{headers}</tr></thead>
              <tbody>
                {users}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalUsers} />
      </div>
    )
  }
}

export default UserTable
